import React from 'react';
import './HostSessionButton.css';

type HostSessionButtonProps = {
  onClick?: () => void;
};

const HostSessionButton: React.FC<HostSessionButtonProps> = ({ onClick }) => (
  <button className="host-session-btn" onClick={onClick}>
    Host Session
  </button>
);

export default HostSessionButton; 